var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#copy_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.85,
    d: "M13.714 0H4.142A.143.143 0 0 0 4 .143v1c0 .079.064.143.142.143H13v12.286c0 .079.064.143.142.143h1a.143.143 0 0 0 .143-.143v-13A.57.57 0 0 0 13.714 0m-2.286 2.286H2.285a.57.57 0 0 0-.571.572v9.476c0 .152.06.297.168.404l3.094 3.095q.06.058.133.098v.034h.075A.6.6 0 0 0 5.38 16h6.048a.57.57 0 0 0 .572-.57V2.857a.57.57 0 0 0-.572-.572m-6.321 11.86-1.538-1.538h1.538zm5.607.569H6.25v-2.536a.714.714 0 0 0-.715-.714H3V3.572h7.714z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "copy_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgCopy;